import { t, type StaffLanguage } from './staffText'

/**
 * How long a declared value is kept, in the words the Fields screen uses.
 *
 * The server checks the same range (catalog.MaxRetentionDays); this copy exists so
 * that a mistyped number is refused in a sentence beside the box rather than by a
 * 422 after Save.
 */

export const MAX_RETENTION_DAYS = 3650

export function retentionProblem(days: number, lang: StaffLanguage): string | null {
  if (!Number.isInteger(days)) return t('catalogue.fields.retentionWholeNumber', lang)
  if (days < 0) return t('catalogue.fields.retentionNegative', lang)
  if (days > MAX_RETENTION_DAYS) return t('catalogue.fields.retentionMax', lang, { max: MAX_RETENTION_DAYS })
  return null
}

/** The card's summary line: what happens to a value, in four words. */
export function retentionSummary(days: number | undefined, lang: StaffLanguage): string {
  if (!days) return t('catalogue.fields.keptWithTicket', lang)
  return t('catalogue.fields.keptDays', lang, { n: days })
}

/** What the screen says after an erasure. Zero is an answer, and the useful one
 *  is where to look for the spelling. */
export function erasedSentence(key: string, n: number, lang: StaffLanguage): string {
  if (n === 0) return t('catalogue.fields.erasedNone', lang, { key })
  return t('catalogue.fields.erased', lang, { key, n })
}
